// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PilN_0Ena9YN56xlR6v7{background:var(--border-neutral-default);flex-grow:1;width:100%;height:100%;display:flex;position:relative}.PilN_0Ena9YN56xlR6v7.QMNjuDsFbgXO0zI1Z3f3{background:var(--background-neutral-default);border-radius:6px}.PilN_0Ena9YN56xlR6v7.QMNjuDsFbgXO0zI1Z3f3 *{pointer-events:none!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `PilN_0Ena9YN56xlR6v7`,
	"viewOnly": `QMNjuDsFbgXO0zI1Z3f3`
};
export default ___CSS_LOADER_EXPORT___;
